const styles = theme => ({
  '@global': {
    '@keyframes spinVinylRecord': {
      '0%': { transform: 'rotate(0deg)' },
      '100%': { transform: 'rotate(360deg)' }
    }
  },
  root: {
    position: 'fixed',
    left: 24,
    bottom: 24,
    zIndex: 1000,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 12,
    padding: [6, 14, 6, 8],
    backgroundColor: 'rgba(10, 10, 12, 0.85)',
    backdropFilter: 'blur(20px)',
    WebkitBackdropFilter: 'blur(20px)',
    borderRadius: 28,
    border: '1px solid rgba(255, 255, 255, 0.14)',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.65), 0 0 1px 1px rgba(255, 255, 255, 0.05)',
    transition: 'all 240ms cubic-bezier(0.16, 1, 0.3, 1)',
    cursor: 'pointer',
    userSelect: 'none',

    '&:hover': {
      backgroundColor: 'rgba(16, 16, 20, 0.94)',
      borderColor: 'rgba(255, 255, 255, 0.3)',
      boxShadow: '0 12px 36px rgba(0, 0, 0, 0.8), 0 0 14px rgba(255, 255, 255, 0.1)',
      transform: 'translateY(-2px)'
    },

    '@media (max-width: 768px)': {
      left: '50%',
      right: 'auto',
      bottom: 14,
      transform: 'translateX(-50%)',
      padding: [5, 14, 5, 8],
      maxWidth: 'calc(100vw - 32px)',

      '&:hover': {
        transform: 'translateX(-50%) translateY(-2px)'
      }
    }
  },
  recordWrapper: {
    position: 'relative',
    width: 36,
    height: 36,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 10,

    '@media (max-width: 768px)': {
      marginRight: 8
    }
  },
  record: {
    position: 'relative',
    width: '100%',
    height: '100%',
    borderRadius: '50%',
    background: [
      'conic-gradient(from 0deg, rgba(255, 255, 255, 0.18) 0deg, transparent 40deg, rgba(255, 255, 255, 0.22) 90deg, transparent 130deg, rgba(255, 255, 255, 0.18) 360deg)',
      'radial-gradient(circle, #252528 0%, #121214 35%, #08080a 70%, #000000 100%)'
    ].join(','),
    boxShadow: [
      'inset 0 0 0 1px rgba(255, 255, 255, 0.12)',
      'inset 0 0 0 3px rgba(0, 0, 0, 0.85)',
      'inset 0 0 0 4px rgba(255, 255, 255, 0.06)',
      'inset 0 0 0 6px rgba(0, 0, 0, 0.9)',
      '0 2px 8px rgba(0, 0, 0, 0.8)'
    ].join(','),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    animation: 'spinVinylRecord 3.6s linear infinite',
    transition: 'filter 250ms ease-out'
  },
  recordUnmuted: {
    filter: 'drop-shadow(0 0 6px rgba(255, 255, 255, 0.45))'
  },
  recordCenter: {
    width: 17,
    height: 17,
    borderRadius: '50%',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    border: '1px solid rgba(255, 255, 255, 0.5)',
    boxShadow: '0 0 4px rgba(0, 0, 0, 0.8)',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '&::after': {
      content: '""',
      width: 3.5,
      height: 3.5,
      borderRadius: '50%',
      backgroundColor: '#ffffff',
      boxShadow: '0 0 2px rgba(0, 0, 0, 0.8)'
    }
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    paddingRight: 4,
    minWidth: 0,
    overflow: 'hidden',
    marginRight: 10,

    '@media (max-width: 768px)': {
      marginRight: 8
    }
  },
  title: {
    fontSize: 12,
    fontWeight: 600,
    fontFamily: theme.typography.primary,
    color: '#ffffff',
    letterSpacing: '0.04em',
    lineHeight: 1.3,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  artist: {
    fontSize: 10.5,
    fontFamily: theme.typography.secondary,
    color: '#a1a1aa',
    lineHeight: 1.25,
    whiteSpace: 'nowrap',
    marginTop: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  button: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 28,
    height: 28,
    borderRadius: '50%',
    backgroundColor: 'transparent',
    border: '1px solid rgba(255, 255, 255, 0.16)',
    color: 'rgba(255, 255, 255, 0.45)',
    cursor: 'pointer',
    transition: 'all 200ms ease-out',
    flexShrink: 0,
    padding: 0,
    outline: 'none',

    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      color: '#ffffff',
      borderColor: 'rgba(255, 255, 255, 0.4)',
      transform: 'scale(1.08)'
    }
  },
  buttonActive: {
    color: '#ffffff',
    borderColor: 'rgba(255, 255, 255, 0.45)',
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
    boxShadow: '0 0 8px rgba(255, 255, 255, 0.2)'
  },
  buttonIcon: {
    display: 'block',
    width: 14,
    height: 14,
    fill: 'currentColor'
  },
  progressTrack: {
    position: 'absolute',
    bottom: 0,
    left: 14,
    right: 14,
    height: 2,
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
    borderRadius: 1,
    overflow: 'hidden',
    pointerEvents: 'none'
  },
  progressFill: {
    height: '100%',
    backgroundColor: '#2dd4bf',
    boxShadow: '0 0 6px rgba(45, 212, 191, 0.8)',
    borderRadius: 1,
    transition: 'width 200ms linear'
  }
});

export { styles };
